import ServiceProviderCreate from './ServiceProviderCreate';

export default ServiceProviderCreate; 


// WEBPACK FOOTER //
// ./resources/assets/js/components/ServiceProviderCreate/index.js